// import React, { useState, useEffect, useCallback } from "react";
// import styles from "./Board.module.css";


// const Board = ({ key, index, setIndex, isButton, isSpeaking, buttonText, images, heading, subHeading, mainContent, tableData, isTable }) => {
//   const [animationClasses, setAnimationClasses] = useState([]);
//   const [triggerAnimation, setTriggerAnimation] = useState(true);
//   const [previousHeading, setPreviousHeading] = useState(heading);
//   const [previousSubHeading, setPreviousSubHeading] = useState(subHeading);

//   const [isDisabled, setIsDisabled] = useState(false);


//   useEffect(() => {
//     setIsDisabled(isButton && !isSpeaking);
//   }, [isButton, isSpeaking]);

//   useEffect(()=>
//   {
//     console.log("isSpeakingEnabled Chaek" ,isSpeaking);
//   },[isSpeaking])

//   const handleClick = () => {
//     setIsDisabled(true);
//     setIndex((prev) => prev + 1);
//   };



//   // Apply animations based on image count and randomization logic


//   // const handleButtonClick = useCallback(() => {
//   //   setIndex((prevIndex) => prevIndex + 1);
//   // }, [setIndex]);

//   return (
//     <div
//       key={key}
//       className={`${styles.bardBoardContainer} ${triggerAnimation ? styles.animate : ""
//         }`}
//     >
//       {/* Render heading */}
//       {heading && <div className={styles.heading}>{heading}</div>}

//       {/* Render subheading */}
//       {subHeading && <div className={styles.subHeading}>{subHeading}</div>}

//       {/* Mid content section */}
//       <div className={styles.bardBoardMidContainer}>
//         <div className={styles.imageSection}>
//           {images &&
//             images.length > 0 && // Check if images is defined and not empty
//             images?.map((image, index) => (
//               <>
//                 {image?.image?.length ? <img
//                   key={index}
//                   src={image?.image}
//                   alt={`Slide ${index + 1}`}
//                   className={`${index >= 2 ? "styles.multiImage" : "styles.image"} ${styles.image} ${animationClasses[index]?.animationClass || ""
//                     }`}
//                   style={{
//                     animationDelay: animationClasses[index]?.animationDelay,
//                   }} // Apply animation delay
//                 /> : null}
//               </>
//             ))}
//         </div>

//         {/* Render main content */}
//         {mainContent && <div className={styles.mainContent}>{mainContent}</div>}
//         {isTable && (
//           <div className={styles.tableContainer}>
//             <h2 className={styles.tableContainertitle}>New Finance</h2>


//             <div className={styles.item}>
//               <div className={styles.label}>Sale Price:</div>
//               <div className={styles.value}>{tableData?.salesPrice}</div>
//             </div>
//             <div className={styles.item}>
//               <div className={styles.label}>Sale Tax:</div>
//               <div className={styles.value}>{tableData?.salesTax}</div>
//             </div>
//             <div className={styles.item}>
//               <div className={styles.label}>MVA Fee:</div>
//               <div className={styles.value}>{tableData?.mvaFee}</div>
//             </div>
//             <hr />
//             <div className={styles.item}>
//               <div className={styles.label}>Total Due</div>
//               <div className={styles.value}>{tableData?.totalDue}</div>
//             </div>
//             <div className={styles.item}>
//               <div className={styles.label}>Down Payment:</div>
//               <div className={styles.value}>-{tableData?.downpayment}</div>
//             </div>
//             <div className={styles.item}>
//               <div className={styles.label}>Trade Allowance Payoff :</div>
//               <div className={styles.value}>-{tableData?.deductibleAmount}</div>
//             </div>
//             <div className={styles.item}>
//               <div className={styles.label}>Base Financed Amount :</div>
//               <div className={styles.value}>{tableData?.financeAmount}</div>
//             </div>
//           </div>
//         )}
//         {/* Render button content */}
//         {buttonText && isSpeaking ? (
//           <button
//           onClick={handleClick}
//           className={styles.btn}
//           disabled={isDisabled}
//         >
//           {buttonText}
//         </button>
//         ):
//         (null)}
//       </div>

//     </div>
//   );
// };

// export default Board;

  // const animationClasses = useMemo(() =>
  //   images.map((_, index) => ({
  //     className: getAnimationClass(index, images),
  //     delay: `${index * 0.8}s`,
  //   })), [images]
  // );

  import React, { useState, useEffect } from "react";
  import styles from "./Board.module.css";
  
  const Board = ({
    componentKey, index, setIndex, isButton, isSpeaking,
    buttonText, images = [], heading, subHeading,
    mainContent, tableData, isTable ,boardBtnText,showBoardBtn ,setboardBtnText,setShowBoardBtn
  }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const [animationClasses, setAnimationClasses] = useState([]);
  
    useEffect(() => {
      setIsDisabled(showBoardBtn && !isSpeaking);
    }, [showBoardBtn, isSpeaking]);
  
    useEffect(() => {
      console.log("isSpeakingEnabled Check:", isSpeaking);
    }, [isSpeaking]);
  
    useEffect(() => {
      if (!images?.length) return;
  
      const availableAnimations = [
        styles.fadeInLeft,
        styles.fadeInRight,
        styles.bounceIn,
        styles.zoomIn,
        styles.slideInLeft,
        styles.slideInRight,
        styles.flashIn,
      ];
  
      const newAnimationClasses = images.map((_, index) => {
        const animationDelay = `${index * 0.8}s`;
        let animationClass;
  
        switch (images.length) {
          case 1:
            // Randomly select an animation for the single image
            animationClass = styles.fadeInRight;
            break;
          case 2:
            animationClass = index === 0 ? styles.fadeInRight : styles.fadeInLeft;
            break;
          case 3:
            animationClass =
              index === 0
                ? styles.slideInRight
                : index === 1
                ? styles.bounceIn
                : styles.slideInLeft;
            break;
          default:
            // For more than 3 images, cycle through the available animations
            animationClass = availableAnimations[index % availableAnimations.length];
        }
  
        return { animationClass, animationDelay };
      });
  
      setAnimationClasses(newAnimationClasses);
    }, [images]);
  
    const handleClick = () => {
      setIsDisabled(true);
      setShowBoardBtn(false)
      setboardBtnText("")
      setIndex((prev) => prev + 1);
    };
  
    return (
      <div key={componentKey} className={`${styles.bardBoardContainer} ${styles.animate}`}>
        {heading && <div className={styles.heading}>{heading}</div>}
        {subHeading && <div className={styles.subHeading}>{subHeading}</div>}
  
        <div className={styles.bardBoardMidContainer}>
          <div className={styles.imageSection}>
            {images.map((image, idx) =>
              image?.image ? (
                <img
                  key={idx}
                  src={image.image}
                  alt={`Slide ${idx + 1}`}
                  className={`${styles.image} ${animationClasses[idx]?.animationClass || ""}`}
                  style={{
                    animationDelay: animationClasses[idx]?.animationDelay || "0s",
                  }}
                />
              ) : null
            )}
          </div>
  
          {mainContent && <div className={styles.mainContent}>{mainContent}</div>}
  
          {isTable && (
            <div className={styles.tableContainer}>
              <h2 className={styles.tableContainertitle}>New Finance</h2>
              {[
                { label: "Sale Price", value: tableData?.salesPrice },
                { label: "Sale Tax", value: tableData?.salesTax },
                { label: "MVA Fee", value: tableData?.mvaFee },
                { label: "Total Due", value: tableData?.totalDue },
                { label: "Down Payment", value: `-${tableData?.downpayment}` },
                { label: "Trade Allowance Payoff", value: `-${tableData?.deductibleAmount}` },
                { label: "Base Financed Amount", value: tableData?.financeAmount },
              ].map(({ label, value }, idx) => (
                <div key={idx} className={styles.item}>
                  <div className={styles.label}>{label}:</div>
                  <div className={styles.value}>{value}</div>
                </div>
              ))}
            </div>
          )}
  
          {showBoardBtn && (
            <>
              {isSpeaking ? (
                <button onClick={handleClick} className={styles.btn} disabled={isDisabled}>
                  {boardBtnText}
                </button>
              ) : (
                <button className={styles.btnDesable} disabled>
                  {boardBtnText}
                </button>
              )}
            </>
          )}
        </div>
       
      </div>
    );
  };
  
  export default Board;